import React from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

const CheckList = ({ title, list }) => (
  <>
    <Typography variant="subtitle2">
      {title}
    </Typography>
    <List dense>
      {list.map((item) => (
        <ListItem key={item} disablePadding>
          <ListItemIcon sx={{ minWidth: 0 }}>
            <CheckIcon color="primary" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </List>
  </>
);

export default CheckList;
